import React, { memo } from 'react';
import { classNameBind } from '@wconcept/wconcept-common/utils/commonUtils';
import * as S from './style';

interface IProps {
  children?: React.ReactNode;
}

const SortingMenuList = ({ children }: IProps) => {
  const cName = classNameBind(['sorting-menu-list']);

  return <S.SortingMenuList className={cName}>{children}</S.SortingMenuList>;
};

export default memo(SortingMenuList);
